import { render, staticRenderFns } from "./DetailTemplateAppDialogMasterSchool.vue?vue&type=template&id=34cd44bd&scoped=true"
import script from "./DetailTemplateAppDialogMasterSchool.vue?vue&type=script&lang=js"
export * from "./DetailTemplateAppDialogMasterSchool.vue?vue&type=script&lang=js"
import style0 from "./DetailTemplateAppDialogMasterSchool.vue?vue&type=style&index=0&id=34cd44bd&lang=css"
import style1 from "./DetailTemplateAppDialogMasterSchool.vue?vue&type=style&index=1&id=34cd44bd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cd44bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34cd44bd')) {
      api.createRecord('34cd44bd', component.options)
    } else {
      api.reload('34cd44bd', component.options)
    }
    module.hot.accept("./DetailTemplateAppDialogMasterSchool.vue?vue&type=template&id=34cd44bd&scoped=true", function () {
      api.rerender('34cd44bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/templateApp/dialog/DetailTemplateAppDialogMasterSchool.vue"
export default component.exports